<template>
    <Head title="Dashboard: Опер аккаунты"/>

    <authenticated-layout :notifications="notifications" >

        <v-navigation />

        <div class="flex flex-col bg-white p-4" v-if="accounts">
            <div class="flex justify-between items-end">
                <div class="w-64">
                    <v-select label="Фильтр по группе" v-model="filter.group">
                        <option :value="null">Показывать все</option>
                        <option v-for="(account, groupName) in accounts" :value="groupName">{{ groupName }}</option>
                    </v-select>
                </div>
                <v-button @click="showAdd = !showAdd">Добавить группу</v-button>
            </div>

            <form v-show="showAdd" method="post" action="#"
                  class="flex flex-row justify-end items-end gap-2"
                  @submit.prevent="send">
                <v-input label="Название" v-model="formAdd.name"/>
                <v-button>Добавить</v-button>
            </form>

            <div class="grid grid-cols-5 p-1 gap-2">
                <strong>Сеть</strong>
                <strong class="col-span-2">Адрес</strong>
                <strong>Баланс</strong>
            </div>

            <div v-if="filter.group === null" class="flex flex-col" v-for="(account, groupName) in accounts">
                <div class="bg-gray-200 p-1">{{ groupName }}</div>
                <div class="grid grid-cols-5 p-1 gap-2" :class="{'bg-gray-100': i%2}" v-for="(items, network, i) in account">
                    <strong :class="`row-span-${items.length}`">{{ network }}</strong>
                    <div class="col-span-4 grid grid-cols-4 gap-2" v-for="item in items">
                        <div class="col-span-2 flex flex-row gap-2 items-center">
                            <span>{{ item.account }}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 fill-current text-green-500" viewBox="0 0 16 16">
                                <title>{{ item.tokens.join(', ') }}</title>
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"/>
                            </svg>
                        </div>
                        <span>{{ item.balance }}</span>
                        <span v-if="item.baseToken">{{ Number(item.balance * item.baseToken.price).toLocaleString([], {style: 'currency', currency: 'USD'}) }}</span>
                    </div>
                </div>
            </div>
            <div v-else class="grid grid-cols-5 p-1 gap-2" :class="{'bg-gray-100': i%2}" v-for="(items, network, i) in accounts[filter.group]">
                <strong :class="`row-span-${items.length}`">{{ network }}</strong>
                <div class="col-span-4 grid grid-cols-4 gap-2" v-for="item in items">
                    <div class="col-span-2 flex flex-row gap-2 items-center">
                        <span>{{ item.account }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 fill-current text-green-500" viewBox="0 0 16 16">
                            <title>{{ item.tokens.join(', ') }}</title>
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                            <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"/>
                        </svg>
                    </div>
                    <span>{{ item.balance }}</span>
                    <span v-if="item.baseToken">{{ Number(item.balance * item.baseToken.price).toLocaleString([], {style: 'currency', currency: 'USD'}) }}</span>
                </div>
            </div>

        </div>

    </authenticated-layout>

</template>

<script>
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VNavigation from '@/Components/Navigation/Dashboard';
import VButton from '@/Components/Button';
import VInput from '@/Components/Input';
import VSelect from '@/Components/Select';

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
        VNavigation,
        VButton,
        VInput,
        VSelect,
    },
    data() {
        return {
            filter: {
                group: null,
            },
            showAdd: false,
            formAdd: useForm({
                name: '',
            })
        }
    },
    props: {
        accounts: Object,
        notifications: Array,
    },
    methods: {
        send() {
            this.showAdd = false;
            this.formAdd.post(route('oper.group.create'));
        }
    },
}
</script>
